<template>
  <div class="dialog-margin fee-dialog">
    <qx-select-table :data="feeList">
      <qx-select-table-column prop="" :label="`${title}说明`" is-slot>
        <template #button>
          <el-button type="text" @click="add">添加</el-button>
        </template>
        <template v-slot="{scope}">
          <el-input v-model="scope.row.remark"/>
        </template>
      </qx-select-table-column>
      <qx-select-table-column label="费用" prop="fee"
                              :item="{attribute:2,precision:2}"/>
      <el-table-column label="操作" width="50px">
        <template slot-scope="scope">
          <div class="table-operator" v-if="!scope.row.isNew">
            <i class="el-icon-third-lajitong" @click="remove(scope.$index)"/>
          </div>
        </template>
      </el-table-column>
    </qx-select-table>
    <div class="control-button padding-10">
      <el-button type="primary" @click="submit">确定</el-button>
      <el-button @click="close">关闭</el-button>
    </div>
  </div>
</template>

<script>
/**
 * @Description: 费用类型编辑弹窗
 * @Author: 菩萨蛮
 * @Date: 2020/10/10 11:54 上午
 * @Version v1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行。
 */

export default {
  name: 'FeeDialog',
  props: {
    fees: { type: Array, default: () => [] },
    title: { type: String, default: '附加费' }
  },
  created() {
    this.feeList = this.utils.copy(this.fees);
  },
  data() {
    return {
      feeList: []
    };
  },
  methods: {
    add() {
      this.feeList.push({
        type: this.title,
        fee: 0,
        remark: ''
      });
    },
    remove(i) {
      this.feeList.splice(i, 1);
    },
    submit() {
      this.$emit('submit', this.feeList);
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
